module.exports = __webpack_public_path__ + "static/img/bg-ar.accdaf7b.png";